module.exports = __webpack_public_path__ + "static/img/3areaB_21.a3c8fe0.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/3areaB_21.png
// module id = 1173
// module chunks = 1